import React, { useEffect, useState } from "react";
import { Table } from "semantic-ui-react";
import fetchDailyCompanyDashboard from "../../services/fetchDailyCompanyDashboard";
import moment from "moment";
import Button from "../../components/Button";
import { toast, ToastContainer } from "react-toastify";
import ButtonContainer from "../../components/ButtonContainer";
import Heading from "../../components/Heading";
import FromToDatePicker from "../../components/FromToDatepicker";
import Loader from "../../components/Loader";
import Dropdown from "../../components/Dropdown/Dropdown";
import user from "../../store/user";

/**
 * @description
 * This component renders a table of company data for a given date range.
 * The component fetches the data from the server when the date range is changed or when the component is mounted.
 * The component also allows the user to filter the data by whether the company is moderated or not.
 * @param {object} param - an object containing the date range and the admin id.
 * @returns {ReactElement} - a table of company data.
 */

export default function DailyCompanyDashboard(param) {
  const moderations = [
    { name: "All", id: 0 },
    { name: "Moderated", id: 1 },
    { name: "Not Moderated", id: 2 },
  ]
  const [dailyData, setdailyData] = useState([]);
  const [adminId, setAdminId] = useState(null);
  const [dateRange, setDateRange] = useState({
    startDate: moment()
      .subtract(1, "day")
      .startOf("day")
      .toDate(),
    endDate: moment()
      .startOf("day")
      .toDate(),
  });
  const [isModerate, setIsModerate] = useState(0); //Here isModerate is for filter in which 0 means all, 1 means only moderated and 2 means only not moderated
  const [isLoading, setIsLoading] = useState(false);

  async function fetchData() {
    const startDate = moment(dateRange.startDate).format();
    const endDate = moment(dateRange.endDate).endOf("day").format();
    setIsLoading(true);
    try{
      const res = await fetchDailyCompanyDashboard(adminId, { startDate, endDate });
      setdailyData(res.data.data);
    }
    catch(err){
      console.log(err);
      toast.error('Something went wrong');
    }
    setIsLoading(false);
  }

  useEffect(() => {
    const getProfile = async () => {
        const profile = await user.getProfile();
        return profile;
    };

    getProfile().then(response => {
        setAdminId(response.id);
    }).catch(error => {
        window.location.href = process.env.REACT_APP_LOGIN_URL;
    })
}, []);

useEffect(() => {
    if (adminId) {
      fetchData();
    }
}, [adminId]);

  /**
   * This function takes an array of company data and returns the count of data that should be displayed
   * given the current value of isModerate.
   * @param {array} data - an array of company data.
   * @returns {integer} - the count of data that should be displayed.
   */
  function countModerate(data) {
    let count = 0;
    for (let i = 0; i < data.length; i++) {
      if (isModerate == 0 ||(isModerate == 1 && data[i].isModerated) || (isModerate == 2 && !data[i].isModerated))//Here isModerate is for filter in which 0 means all, 1 means only moderated and 2 means only not moderated
        count++;
    }
    return count;
  }

  return (
    <div>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable={false}
        pauseOnHover
      />
      <div className="page-heading">
        <Heading text="Daily Company Dashboard" />
      </div>
      <div className="row">
        <ButtonContainer heading="Date:">
          <li>
            <div className="date-picker">
              <div className="form-group date">
                <div className="col-sm-6 left valueBox">
                  <FromToDatePicker
                    name="date"
                    startDate={dateRange.startDate}
                    endDate={dateRange.endDate}
                    maxDate={
                      Math.min(moment(dateRange.startDate).add(1, "month").toDate() ,  moment().toDate())
                    }
                    handleChangeStart={(e) => {
                      setDateRange({
                        startDate: e,
                        endDate:null
                      });                
                    }}
                    handleChangeEnd={(e) => {
                      setDateRange({
                        ...dateRange,
                        endDate: e,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </li>
          <li>
            <Button
              skin="dark"
              disabled={false}
              text="Search"
              clickButton={fetchData}
            ></Button>
          </li>
        </ButtonContainer>
        <div className="right">
          <Dropdown
            data={moderations}
            dropdownChange={(e) => setIsModerate(e.target.value)}
            defaultValue={isModerate}
          />
        </div>
      </div>
      <div className="row"> Total number of records: {dailyData.length > 0 ? countModerate(dailyData) : 0}</div>
      {isLoading ? (
        <Loader />
      ) : dailyData.length == 0 ? (
        <div>No data found</div>
      ) : (
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>S.No.</Table.HeaderCell>
              <Table.HeaderCell>Last Posted Date</Table.HeaderCell>
              <Table.HeaderCell>Company ID</Table.HeaderCell>
              <Table.HeaderCell>Is Moderated</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {/* Here isModerate is for filter in which 
          0 means all,
          1 means only moderated ,
          2 means only not moderated  
          */}
         <Table.Body>
           {dailyData
             .filter((item) =>
               (isModerate == 0) ||
               (isModerate == 1 && item.isModerated) ||
               (isModerate == 2 && !item.isModerated)
             )
             .map((item, index) => (
               <Table.Row key={item.companyId}>
                 <Table.Cell>{index + 1}</Table.Cell>
                 <Table.Cell>{item.lastPostedDate}</Table.Cell>
                 <Table.Cell>
                   <a
                     href={`/managementCompany/${item.companyId}?status=1`}
                     target="_blank"
                   >
                     {item.companyId}
                   </a>
                 </Table.Cell>
                 <Table.Cell>{item.isModerated ? "Yes" : "No"}</Table.Cell>
               </Table.Row>
             ))}
         </Table.Body>
        </Table>
      )}
    </div>
  );
}
